export enum RolePreconditionType {
  SYNCED = 'synced',
  APPROVED = 'approved',
  PENDING = 'pending',
}
